import EventBus from '../../event-bus.vue.js';
export const ListWViewMore = {
  template: `
  <div class="list-w-view-more-content">
    <div class="relative"  @click.stop="display(component)" >
    <!--
    <div v-if="!hasItems()" class="absolute top-0 bottom-0 left-0 right-0 bg-secondary opacity-75"></div>
    -->  
      <div v-if="disabled" class="absolute top-0 bottom-0 left-0 right-0 bg-customGray opacity-75 search-dropdown-content"></div>
      <div class="w-full flex content-between border border-primary list-w-view-more-title-section"
           role="button"
           tabindex="0"
           :aria-expanded="show ? 'true' : 'false'"
           :aria-controls="'lbx-filter-' + component"
           :aria-disabled="disabled ? 'true' : null"
           @keydown.enter.prevent.stop="display(component)"
           @keydown.space.prevent.stop="display(component)">
        <div @click.stop="display(component)" class="relative flex items-center pl-3 p-2 lg:pl-3 lg:p-1 w-full text-left bg-primary text-sm text-white font-antenna-cond-bold overflow-hidden cursor-pointer uppercase list-w-view-more-title-text">
          {{displayName}}
          <span class="absolute right-0 select-none pr-3">
            <svg aria-hidden="true" focusable="false" :class="{'rotate-180': show}" width="14" height="10" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0L8 10.5245L16 0H13.3333L8 7.23556L2.66667 0H0Z" fill="#FFFFFF"/>
            </svg>
          </span>
        </div>
      </div>
      <transition name="fade">
      <div @click.stop="" v-if="show" :id="'lbx-filter-' + component" :class="[isResponsive ? 'lg:absolute' : '', !expanded ? 'h-auto max-h-[100px]' : '']" class="px-3 pt-2 w-full z-50 bg-white list-w-view-more-items" style="overflow-y: hidden;">
        <div class="list-w-view-more-item" v-for="item in items">
          <label class="custom-checkbox text-left">
            {{$t(item)}} <small>{{getCount(item)}}</small>
            <input
              @change="toggle(component, item)"
              :key="item" 
              type="checkbox"
              :value="item"
              :name="item"
              :disabled="!this.enabled ? disabled : false"
              :checked="selected.includes(item) || (items.length == 1 && component == 'model' && (allSelected?.make.length == 0))">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
      </transition>
    </div>
    <p v-show="!showAllOptions && !expanded && items.length > 4 && show" @click="expand(true)" class="text-left p-3 cursor-pointer text-blue list-w-view-more-button">{{$t('View more')}}</p>
    <p v-show="!showAllOptions && expanded && items.length > 4 && show" @click="expand(false)" class="text-left p-3 cursor-pointer text-blue list-w-show-less-button">{{$t('Show less')}}</p>
  </div>
  `,
  data: function () {
    return {
      // `show-all-options` filter setting: start expanded (full list, no
      // "View more"/"Show less" toggle). Defaults to the collapsed behaviour.
      expanded: this.showAllOptions === true,
      show: true,
      uniqueInList: null,
      loaded: false,
      theme_directory: window.theme_directory,
      selected: this.initialSelection,
      enable: true,
      externalDisplayName: null,
    }
  },
  props: [
    'component',
    'title',
    'items',
    'initialSelection',
    'collapse',
    'pivot',
    'disable-responsive',
    'optionsCount',
    'allSelected',
    'showAllOptions',
  ],
  created(){
  },
  mounted(){
    EventBus.$on('CLEAR_ALL_NEW_TOGGLE_LIST_ABSOLUTE_ADVANCED_SELECTION', () => {
      this.clearSelection();
    });

    // LBT-1461: keep the "feature" selection in sync with the horizontal
    // Popular Features bar (feature-quick-bar), which can live in a different
    // component/instance. Display-only mirror; the parent already owns
    // selected.feature for filtering/URL. Guard by component + source _uid.
    EventBus.$on('SYNC_FEATURE_SELECTION', (payload) => {
      if (this.component !== 'feature') return;
      if (!payload || payload.source === this._uid) return;
      this.selected = Array.isArray(payload.selected) ? payload.selected.slice() : [];
    });
  },
  methods: {
    getCount(item){
      if(this.optionsCount && this.optionsCount[item])
        return `(${this.optionsCount[item]})`
      else
        return ""
    },
    entryPoint(items){
        this.selected = items.filter(i => {
          if(this.initialSelection.includes(i.replace(/ /g, '-').replace(/---/g, '-').toLowerCase()))
            return i;
        })

      this.$emit('updatechecked', {
        component: this.component,
        selected: this.selected,
      })
    },
    clearSelection() {
      this.selected = [];
      this.expanded = this.showAllOptions === true;
      this.$emit('updatechecked', {
        component: this.component,
        selected: this.selected,
      })
    },
    display() {
      if(!this.hasItems() || !this.enable)
        return;
      this.show = !this.show;
    },
    expand(val){
      this.expanded = val;
    },
    hasItems(){
      return this.items.length > 0;
    },
    toggle(component, item) {
      if(this.selected.includes(item))
        this.selected.splice(this.selected.indexOf(item), 1);
      else
        this.selected.push(item);

      this.$emit('updatechecked', {
        component,
        selected: this.selected,
      })

      // LBT-1461: mirror feature toggles to the horizontal bar.
      if (component === 'feature') {
        EventBus.$emit('SYNC_FEATURE_SELECTION', {
          source: this._uid,
          selected: this.selected.slice(),
        });
      }
    },
  },
  watch:{
    items(items){
      if(!this.loaded)
      {
        this.entryPoint(items);
        this.loaded = true;
      }
    }
  },  
  computed: {
    disabled(){
      return !this.hasItems() || !this.enable;
    },
    displayName(){
      if(this.externalDisplayName)
        return this.externalDisplayName;
      if(this.selected.length == 0)
        return this.title;
      else
        if(this.selected.length > 2)
          return `${this.selected.slice(0, 2).join(',')}...`;
        else
          return this.selected.join(',');
    },
    isResponsive(){
      return !this.disableResponsive == true;
    }
  }
}